<template>
  <div
    :class="[
      'asc-switch',
      isProjectZeus ? 'asc-switch--accent' : '',
      singleLine ? 'asc-switch--single-line' : '',
    ]"
  >
    <asc-label size="sm" :value="label"></asc-label>
    <v-switch
      v-model="model"
      :label="getLabel"
      :disabled="$attrs.disabled"
      :hide-details="hideDetails"
      @change="handleChange"
    ></v-switch>
  </div>
</template>

<script>
import AscLabel from './AscLabel'
import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscSwitch',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    singleLine: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      viewModel: this.value,
    }
  },

  computed: {
    model: {
      get() {
        return this.viewModel
      },
      set(newValue) {
        this.viewModel = newValue
      },
    },
    isProjectZeus() {
      return AppFeatureFlags.getProjectZeus()
    },
    getLabel() {
      return this.viewModel ? 'On' : 'Off'
    },
  },

  watch: {
    value(newValue) {
      this.viewModel = newValue
    },
  },

  methods: {
    handleChange(option) {
      this.model = option
      this.$emit('input', this.model)
    },
  },
}
</script>

<style lang="scss">
.asc-switch {
  & .asc-label {
    margin-bottom: 8px;
  }

  & .v-input--switch {
    margin-top: 0;
    padding-top: 0;

    & .v-label {
      font-size: 12px;
      color: $gray-500;
    }

    & .v-input--selection-controls__input {
      width: 40px;

      & .v-input--selection-controls__ripple {
        display: none;
      }

      & .v-input--switch__track {
        height: 18px;
        top: calc(50% - 9px);
        border-radius: 12px;
        background-color: $gray-700;
      }

      & .v-input--switch__thumb {
        height: 14px;
        width: 14px;
        left: 5px;
        color: $primary-white !important;
        top: calc(50% - 7px);
      }
    }
  }

  & .v-input--switch.v-input--is-label-active {
    & .v-label {
      color: $primary-black;
    }
  }
}

.asc-switch--accent {
  & .v-input--switch__track {
    background-color: $gray-700;
    opacity: 1;
  }

  & .v-input--switch.v-input--is-label-active {
    & .v-input--switch__track {
      background-color: $accent-500;
      opacity: 1;
    }
  }
}

.asc-switch--single-line {
  display: flex;

  .asc-label {
    padding: 3px 4px 0 0;
  }
}
</style>
